import React, { useRef, useState }  from 'react';
import emailjs from '@emailjs/browser';
import { Footer } from '../../../../containers';
import { Navbar } from '../../../../components';
import './Paroxes-Ypiresiwn.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../../../assets/OEFE.jpg';
import labora from '../../../../assets/labora.jpg';
import edu4schools from '../../../../assets/edu4schools.png';
import ypourgeio from '../../../../assets/ypourgeio.jpg';


const categories = [
  { title: "1", image: require("./Photo/1.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "2", image: require("./Photo/2.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "3", image: require("./Photo/3.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "4", image: require("./Photo/4.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "5", image: require("./Photo/5.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "6", image: require("./Photo/6.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "7", image: require("./Photo/7.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "8", image: require("./Photo/8.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "9", image: require("./Photo/9.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "10", image: require("./Photo/10.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "11", image: require("./Photo/11.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "12", image: require("./Photo/12.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "13", image: require("./Photo/13.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "14", image: require("./Photo/14.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "15", image: require("./Photo/15.JPEG"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." },
  { title: "16", image: require("./Photo/16.jpeg"), description: "Πληροφορίες για το εκπαιδευτικό υλικό." }
];

const styles = {
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    padding: "20px",
    maxWidth: "1000px",
    margin: "auto",
  },
  gridItem: {
    background: "white",
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
    textAlign: "center",
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s ease-in-out",
    cursor: "pointer",
  },
  gridItemHover: {
    transform: "scale(1.05)",
  },
  gridImage: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
  },
  title: {
    padding: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    background: "#f8f8f8",
  },
  fullscreenOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "1000",
    padding: "20px",
    textAlign: "center",
  },
  fullscreenImage: {
    maxWidth: "90%",
    maxHeight: "70%",
    
  },
  description: {
    color: "white",
    marginTop: "20px",
    fontSize: "18px",
    maxWidth: "80%",
  }
};


const Paroxes = () => {

  const [fullscreenContent, setFullscreenContent] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);


  const form = useRef();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
      .then((result) => {
          console.log(result.text);
          console.log("message sent");
          e.target.reset();
          setShowSuccess(true);
          setShowError(false);
      }, (error) => {
          console.log(error.text);
          setShowSuccess(false);
          setShowError(true);
      });
  };

  const closePopup = () => {
    setShowSuccess(false);
    setShowError(false);
  };
  return (
    <div className="Paroxes">
        <div className="gradient__bg">
          <Navbar className="navbar" />
        </div>
        <div className="Paroxes__main-container">
          <div className="Paroxes__container">
            <div className="Paroxes__container-h">
              <h1>ΠΑΡΟΧΕΣ ΥΠΗΡΕΣΙΩΝ</h1>
            </div>
            <div style={styles.gridContainer}>
              {categories.map((category, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.gridItem,
                    ...(hoverIndex === index ? styles.gridItemHover : {}),
                  }}
                  onClick={() => setFullscreenContent(category)}
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(null)}
                >
                  <img src={category.image} alt={category.title} style={styles.gridImage} />
                  <div style={styles.title}>{category.title}</div>
                </div>
              ))}
            </div>
            {fullscreenContent && (
              <div
                style={styles.fullscreenOverlay}
                onClick={() => setFullscreenContent(null)}
              >
                <img src={fullscreenContent.image} alt="Fullscreen" style={styles.fullscreenImage} />
                <p style={styles.description}>{fullscreenContent.description}</p>
              </div>
            )}
            <div className="Paroxes__container-p">
            <p>&nbsp;&nbsp;&nbsp;Το φροντιστήριο από το 1999 δραστηριοποιείται στον τομέα της παροχής εκπαιδευτικών υπηρεσιών σε φροντιστηριακό επίπεδο για την Δευτεροβάθμια εκπαίδευση.</p>
                  <p>&nbsp;&nbsp;&nbsp;Διδάσκονται μαθήματα Μέσης Εκπαίδευσης σε μαθητές Γυμνασίου και Α', Β' , Γ’ Λυκείου και ΕΠΑ.Λ. καθώς τους προετοιμάζει για τις πανελλαδικές εξετάσεις. Τα μαθήματα που διδάσκονται είναι:
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Μαθηματικά Προσανατολισμού,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Έκθεση & Λογοτεχνία,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Φυσική-Χημεία Προσανατολισμού,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Βιολογία Προσανατολισμού,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Αρχές Οικονομικής Θεωρίας (Οικονομία),</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Ανάπτυξη Εφαρμογών σε Προγραμματιστικό Περιβάλλον (Α.Ε.Π.Π.),</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Αρχαία,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Λατινικά,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Ιστορία ,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Άλγεβρα & Γεωμετρία,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Φυσική-Χημεία γενικής παιδείας,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; ΑΟΔΕ (Αρχές Οργάνωσης και Διοίκησης Επιχειρήσεων),</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Υγιεινή & Ανατομία,</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x21D2; Δίκτυα & Προγραμματισμός,</p>
            </p>
              <p>&nbsp;&nbsp;&nbsp;Παρέχουμε:
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Ομοιογενή τμήματα</p> 
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Συνεχής επικοινωνία με μαθητές και γονείς</p> 
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Εκδηλώσεις επαγγελματικού προσανατολισμού</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Προγραμματισμένα  διαγωνίσματα</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Συχνά test κατά την εκτίμηση του υπεύθυνου καθηγητή</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Test Επαγγελματικού Προσανατολισμού</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Επαναληπτικά διαγωνίσματα της ΟΕΦΕ</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Πλούσιο Εκπαιδευτικό Υλικό</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Σύγχρονοι μέθοδοι διδασκαλίας μέσω διαδραστικών πινάκων</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Χρήση Πληροφοριακών συστημάτων (Έπαφος)</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Υπολογισμός επιδόσεων των μαθητών μας και επαναξιολόγηση των αρχικών τους στόχων</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Προσομοίωση συμπλήρωσης μηχανογραφικού δελτίου</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Συμπληρωματικές δραστηριότητες της εκπαιδευτικής διαδικασίας</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Διανομή ενημερωτικών φυλλαδίων (σχολές, βάσεις, κτλ)</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Εκδηλώσεις εκπαιδευτικού και ψυχολογικού χαρακτήρα</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Καθοδήγηση για τη συμπλήρωση των αιτήσεων σύμφωνα με τις  προκηρύξεις των ένστολων σχολών</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Καθοδήγηση για την τελική συμπλήρωση του μηχανογραφικού δελτίου</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Παροχή συγγραμμάτων</p>
                  <p>&nbsp;&nbsp;&nbsp;&#x27A4; Συνεργασία με ψυχολόγο και λογοθεραπευτή</p>
              </p>
            </div>
          </div>
          <div className="Paroxes__side-Containers">
            <div className="Paroxes__side-Container1">
              <h1>Χρήσιμες Σελίδες</h1>
              <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Σημεία Υπεροχής
                      </AccordionItemButton>
                    </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                        </p>
                        <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </a>
                        </AccordionItemPanel>
                  </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        "Ομάδα ή Μονάδα" ;
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO- 
                          </p>
                          <a href="/OmadaMonada" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                          </p>
                          <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Σχόλια Μαθητών
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας . 
                          </p>
                          <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            </div>
            <div className="anodos__alykeiou-email-container">
              <form className="anodos__alykeiou-email-container_form" ref={form} onSubmit={sendEmail}>
                <h1 className="anodos__alykeiou-email-container_h1">Φόρμα Επικοινωνίας</h1>
                <label className="anodos__alykeiou-email-container_label">Όνομα</label>
                <input className="anodos__alykeiou-email-container_input" type="text" name="user_name" required/>
                <label className="anodos__alykeiou-email-container_label">Email</label>
                <input className="anodos__alykeiou-email-container_input" type="email" name="user_email" required/>
                <label className="anodos__alykeiou-email-container_label">Μήνυμα</label>
                <textarea className="anodos__alykeiou-email-container_input-message" name="message" required/>
                <input className="anodos__alykeiou-email-container_btn" type="submit" value="Αποστολή" />
              </form>

              {showSuccess && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--success">
                  <span>Your message was sent successfully!</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}

              {showError && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--error">
                  <span>There was an error sending your message. Please try again later.</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}
              </div>
            <div className="anodos__Alykeiou-links-container">
                <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                </a>
                <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                </a>
                <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                </a>
                <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                </a>
            </div>
          </div>
        </div>
        <Footer />
    </div>
  )
}

export default Paroxes